import AchPayment from './MsoAchPayment.jsx';

export default AchPayment;


// WEBPACK FOOTER //
// ./src/components/MsoAchPayment/index.jsx